module.exports = __webpack_public_path__ + "038cc0058ccd12e4362849ec0864999c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/applications/orca-loader.gif
// module id = 2395
// module chunks = 0